const orderConditions = (is_referral = false) => {
  if (is_referral) {
    return ['join_program', 'referral_bet_sum', 'affiliate_bet_sum']
  }
  return ['join_program', 'invite_referrals', 'referral_bet_sum', 'affiliate_bet_sum']
}

export { orderConditions }
